export default {
    imageDashboardTransaction: {
        action: 'Åtgärd',
        transactionId: 'Transaktions-ID',
        variationCount: 'Variationsantal',
        date: 'Datum',
        cost: 'Kostnad',
        description: 'Beskrivning',
        selectedImage: 'Utvald bild',
        goTo: 'Gå till',
    },
};
